export const iconFontAwesomeSecurityPassport = (
	<i className="fa-solid fa-passport"></i>
);
